import { NOTIFIED_MATCHES, NOTIFIED_TICKETS } from '@/routing/routes';
import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';

function NotificationsTabs({ active }) {
    const scrollElementRef = useHeaderTabsScroll();
    return (
        <HeaderTabsContainer>
            <TabButton
                route={NOTIFIED_MATCHES}
                i18nCode="matches"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={NOTIFIED_TICKETS}
                i18nCode="menu.tikety"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
        </HeaderTabsContainer>
    );
}

export default NotificationsTabs;
